/**
 * BattleBagBuilder — populates a ModifierBag from the player's state.
 *
 * Called at the start of each battle. Collects modifiers from:
 *   1. Base stats (attack, maxAp, maxHp — always present)
 *   2. Skills (via SkillRegistry)
 *   3. Perks (via SkillRegistry)
 *
 * Status effects are added/removed dynamically during combat,
 * not through this builder.
 */

import { ModifierBag } from "../../../framework/stats";
import { PlayerCharacter } from "../PlayerCharacter";
import * as S from "./StatKeys";

/**
 * Build a fresh ModifierBag for a battle.
 * Each system pushes its modifiers; consumers only query the bag.
 */
export function buildBattleBag(player: PlayerCharacter): ModifierBag {
  const bag = new ModifierBag();

  // --- Base stats ---
  bag.add(S.DAMAGE, "flat", player.baseAttack, "Base ATK");
  bag.add(S.AP_MAX_FLAT, "flat", player.maxAp, "Base AP");
  bag.add(S.MAX_HP_FLAT, "flat", player.maxHp, "Base HP");

  // --- Skills & Perks ---
  player.skills.applyAll(bag);

  return bag;
}
